import * as i0 from '@angular/core';
import { Directive, HostBinding, contentChildren, viewChild, inject, Renderer2, input, model, signal, computed, output, effect, Component, ChangeDetectionStrategy } from '@angular/core';
import { DOCUMENT, NgStyle, NgClass, NgTemplateOutlet } from '@angular/common';
import { NgxSwipeDetectorDirective } from '@digipay/ngx-swipe-detector';
import { NgxButtonComponent } from '@digipay/ngx-button';
const _c0 = ["ngxDpCarouselItemsContainer"];
const _c1 = ["ngxDpCarouselMainContainer"];
const _forTrack0 = ($index, $item) => $item.slide;
const _c2 = a0 => ({
  padding: a0
});
const _c3 = a0 => ({
  cards: a0
});
const _c4 = a0 => ({
  active: a0
});
const _c5 = () => ({
  name: "arrow-left",
  type: "linear"
});
const _c6 = () => ({
  name: "arrow-right",
  type: "linear"
});
function NgxDpCarouselComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementContainer(1, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const wrapper_r2 = ctx.$implicit;
    const $index_r3 = ctx.$index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("slide-wrapper d-flex justify-content-center " + ctx_r3.slideWrapperClasses()[$index_r3]);
    i0.ɵɵstyleProp("overflow", ctx_r3.isSlideOverflowVisible() ? "visible" : "hidden");
    i0.ɵɵclassProp("clone", wrapper_r2.isClone);
    i0.ɵɵproperty("ngStyle", ctx_r3.slideWrapperCustomStyles()[$index_r3]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", wrapper_r2.slide.templateRef);
  }
}
function NgxDpCarouselComponent_Conditional_6_Conditional_2_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const dot_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c4, dot_r5 === ctx_r3.index()));
  }
}
function NgxDpCarouselComponent_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵrepeaterCreate(1, NgxDpCarouselComponent_Conditional_6_Conditional_2_For_2_Template, 1, 3, "div", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("dots radius-big d-flex flex-row gap-tiny surface-back " + ctx_r3.navDotsContainerClasses());
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r3.dots());
  }
}
function NgxDpCarouselComponent_Conditional_6_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 11);
    i0.ɵɵlistener("clickHandler", function NgxDpCarouselComponent_Conditional_6_Conditional_3_Conditional_1_Template_ngx_button_clickHandler_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.handleNavigationBtnClick("PREV"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleMap("tinted-on-elevated");
    i0.ɵɵproperty("mode", ctx_r3.navigationButtonPrevText() !== "" ? "section" : "icon-only")("size", ctx_r3.navigationButtonSize())("leftIcon", i0.ɵɵpureFunction0(6, _c6));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.navigationButtonPrevText(), " ");
  }
}
function NgxDpCarouselComponent_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, NgxDpCarouselComponent_Conditional_6_Conditional_3_Conditional_1_Template, 2, 7, "ngx-button", 10);
    i0.ɵɵelementStart(2, "ngx-button", 11);
    i0.ɵɵlistener("clickHandler", function NgxDpCarouselComponent_Conditional_6_Conditional_3_Template_ngx_button_clickHandler_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.handleNavigationBtnClick("NEXT"));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r3.index() !== 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("mode", ctx_r3.navigationButtonNextText() !== "" ? "section" : "icon-only")("size", ctx_r3.navigationButtonSize())("leftIcon", i0.ɵɵpureFunction0(5, _c5));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.navigationButtonNextText(), " ");
  }
}
function NgxDpCarouselComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 2);
    i0.ɵɵtemplate(2, NgxDpCarouselComponent_Conditional_6_Conditional_2_Template, 3, 2, "div", 6)(3, NgxDpCarouselComponent_Conditional_6_Conditional_3_Template, 4, 6, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("navigation-container p-medium d-flex flex-row radius-minus align-items-center " + ctx_r3.navContainerClasses());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, ctx_r3.showDots() && ctx_r3.dots().length > 0 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, ctx_r3.showButtons() ? 3 : -1);
  }
}
let NgxDpCarouselSlideDirective = /*#__PURE__*/(() => {
  class NgxDpCarouselSlideDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
      this.isNext = false;
      this.isPrev = false;
    }
    static {
      this.ɵfac = function NgxDpCarouselSlideDirective_Factory(t) {
        return new (t || NgxDpCarouselSlideDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxDpCarouselSlideDirective,
        selectors: [["ng-template", "ngxDpCarouselSlide", ""]],
        hostVars: 4,
        hostBindings: function NgxDpCarouselSlideDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("is-next", ctx.isNext)("is-prev", ctx.isPrev);
          }
        },
        standalone: true
      });
    }
  }
  return NgxDpCarouselSlideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let lastId = 0;
function UniqueComponentId(prefix = 'dpx_id_') {
  lastId++;
  return `${prefix}${lastId}`;
}
function isEqual(value1, value2) {
  // Check if the values are strictly equal
  if (value1 === value2) {
    return true;
  }
  // Check for null and undefined
  if (value1 == null || value2 == null) {
    return false;
  }
  // Check for different types
  if (typeof value1 !== typeof value2) {
    return false;
  }
  // If both values are arrays, compare them element by element
  if (Array.isArray(value1) && Array.isArray(value2)) {
    if (value1.length !== value2.length) {
      return false;
    }
    for (let i = 0; i < value1.length; i++) {
      if (!isEqual(value1[i], value2[i])) {
        return false;
      }
    }
    return true;
  }
  // If both values are objects, compare their keys and values
  if (typeof value1 === 'object' && typeof value2 === 'object') {
    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (!isEqual(value1[key], value2[key])) {
        return false;
      }
    }
    return true;
  }
  // For all other types, consider them not equal if the above checks don't apply
  return false;
}
let NgxDpCarouselComponent = /*#__PURE__*/(() => {
  class NgxDpCarouselComponent {
    constructor() {
      this.slides = contentChildren(NgxDpCarouselSlideDirective);
      this.itemsContainer = viewChild.required('ngxDpCarouselItemsContainer');
      this.mainContainer = viewChild.required('ngxDpCarouselMainContainer');
      // Injections
      this.renderer = inject(Renderer2);
      this.document = inject(DOCUMENT);
      // Inputs
      this.visibleItemCount = input(1);
      this.numScroll = input(1);
      this.carouselPadding = input('');
      this.mode = input('SINGLE');
      this.mainContainerClasses = input('');
      this.swipeThreshold = input(30);
      this.fixedWidth = input(0);
      this.fixedGap = input(0);
      this.itemsContainerVerticalPadding = input(undefined);
      this.index = model(0);
      this.scaleAmount = input(0.7);
      this.isFixedWidth = input(false);
      this.isFixedGap = input(false);
      this.centerMode = input(true);
      this.disableScaling = input(false);
      this.showNavigation = input(true);
      this.showDots = input(true);
      this.showButtons = input(true);
      this.isSlideOverflowVisible = input(false);
      this.navigationContainerClasses = input('');
      this.navigationDotsContainerClasses = input('');
      this.disableNavigationDots = input(false);
      this.navigationButtonSize = input('medium');
      this.navigationButtonNextText = input('');
      this.navigationButtonPrevText = input('');
      this.scalingTransformOrigin = input('center bottom');
      this.changeStepThresholdPercentage = input(50, {
        transform: value => Math.min(90, Math.max(10, value))
      });
      this.enableAutoPlay = input(false);
      this.autoPlayDurationMillis = input(3000);
      this.autoPlayCounts = input(0); // 0 is infinite
      this.autoPlayRebootDurationMillis = input(10000);
      this.stepWidth = signal(0);
      this.loopMode = input(false);
      this.loopStartHotSpot = computed(() => this.getHotSpot('START'));
      this.loopEndHotSpot = computed(() => this.getHotSpot('END'));
      this.previousIndex = this.index();
      this.lastNavigationDirection = computed(() => this.previousIndex > this.index() ? 'PREV' : 'NEXT');
      // Outputs
      this.navigationBtnClicked = output();
      this.isAnimationRunning = output();
      this.singleTapped = output();
      this.isSwiping = output();
      this.isDragging = false;
      this.currentWalkX = 0;
      this.lastLeft = 0;
      this.calculatedGap = signal(0);
      this.calculatedWidth = signal(0);
      this.mainContainerWidth = signal('');
      this.mainContainerGap = signal('');
      this.mainContainerPadding = signal('');
      this.isSwipingVertically = false;
      this.transitionSteps = signal([]);
      this.isAnimating = false;
      this.dots = computed(() => {
        if (!this.wrappers().length) return [];
        return this.wrappers().map((item, i) => i);
      });
      this.autoPlayExecutedCount = 0;
      this.navContainerClasses = computed(() => {
        let classes = [];
        if (this.showDots() && this.showNavigation() && !this.onlyOneNavigation()) {
          classes.push('justify-content-space-between');
        }
        if (this.onlyOneNavigation()) {
          classes.push('justify-content-center');
        }
        if (this.navigationContainerClasses() !== '') {
          classes.push(this.navigationContainerClasses());
        }
        return classes.join(' ');
      });
      this.navDotsContainerClasses = computed(() => {
        let classes = [];
        classes.push(this.disableNavigationDots() ? 'surface-transparent' : 'p-low');
        if (this.navigationDotsContainerClasses() !== '') {
          classes.push(this.navigationContainerClasses());
        }
        return classes.join(' ');
      });
      this.onlyOneNavigation = computed(() => this.showDots() !== this.showButtons());
      this.cloneCount = computed(() => Math.ceil(this.visibleItemCount()));
      this.wrappers = computed(() => {
        const slides = this.slides();
        if (!slides.length) {
          return [];
        }
        if (!this.loopMode()) {
          return slides.map((slide, i) => ({
            slide,
            index: i,
            isClone: false
          }));
        }
        const cloneCount = this.cloneCount();
        const prefix = slides.slice(-cloneCount).map((slide, i) => {
          return {
            slide,
            index: slides.length - cloneCount + i,
            isClone: true
          };
        });
        const main = slides.map((slide, i) => {
          return {
            slide,
            index: i,
            isClone: false
          };
        });
        const suffix = slides.slice(0, cloneCount).map((slide, i) => {
          return {
            slide,
            index: i,
            isClone: true
          };
        });
        return [...prefix, ...main, ...suffix];
      });
      this.slideWrapperCustomStyles = computed(() => {
        const w = this.calculatedWidth() + 'px';
        const defaultStyles = {
          'min-width': w,
          'max-width': w
        };
        return this.wrappers().map((_, i) => {
          if (this.mode() === 'CARD') {
            if (i === this.index()) {
              return {
                ...defaultStyles,
                transform: 'scale(1)',
                transition: 'transform 0.5s ease-in-out',
                transformOrigin: this.scalingTransformOrigin()
              };
            } else {
              return {
                ...defaultStyles,
                transform: this.disableScaling() ? 'scale(1)' : `scale(${this.scaleAmount()})`,
                transition: 'transform 0.5s ease-in-out',
                transformOrigin: this.scalingTransformOrigin()
              };
            }
          } else {
            return {
              ...defaultStyles
            };
          }
        });
      });
      this.slideWrapperClasses = computed(() => {
        return this.wrappers().map((_, i) => {
          const classes = [];
          if (this.mode() === 'SINGLE') {
            classes.push('carousel-item');
            if (this.index() === i) {
              classes.push('active');
            }
          }
          return classes.join(' ');
        });
      });
      effect(() => {
        if (this.index() !== undefined) {
          if (this.transitionSteps().length === 0) {
            this.calculateSteps();
          }
          if (this.index() === 0) {
            this.step(false);
          } else if (this.index() !== this.previousIndex) {
            this.previousIndex = this.index();
            this.step(false);
          }
        }
        if (this.wrappers().length) {
          const slides = this.wrappers().map(wrapper => wrapper.slide);
          const currentSlides = slides.slice();
          if (!this.previousSlides || !isEqual(currentSlides, this.previousSlides)) {
            this.previousSlides = [...currentSlides];
            this.calculateWidthAndGap();
            this.calculateSteps();
            this.startAutoPlay();
          }
        }
      }, {
        allowSignalWrites: true
      });
    }
    ngAfterContentInit() {
      this.id = UniqueComponentId();
    }
    getHotSpot(position) {
      if (!this.stepWidth() && !this.transitionSteps().length) return 0;
      return this.transitionSteps()[position === 'START' ? 1 : this.transitionSteps().length - this.visibleItemCount()];
    }
    calculateWidthAndGap() {
      const mainWidth = this.roundIt(this.mainContainer().nativeElement.getBoundingClientRect().width);
      // Just Fixed Width
      if (this.isFixedWidth() && !this.isFixedGap()) {
        this.calculatedWidth.set(this.fixedWidth());
        this.calculatedGap.set(this.roundIt((mainWidth - this.visibleItemCount() * this.fixedWidth()) / this.visibleItemCount()));
      }
      // Just Fixed Gap
      if (this.isFixedGap() && !this.isFixedWidth()) {
        this.calculatedWidth.set(this.roundIt((mainWidth - this.visibleItemCount() * this.fixedGap()) / this.visibleItemCount()));
        this.calculatedGap.set(this.fixedGap());
      }
      // Fixed Gap And Width
      if (this.isFixedGap() && this.isFixedWidth()) {
        this.calculatedWidth.set(this.fixedWidth());
        this.calculatedGap.set(this.fixedGap());
      }
      this.setWrappersWidthAndGap(this.calculatedWidth(), this.calculatedGap());
      if (this.transitionSteps().length === 0) {
        this.calculateSteps();
      }
    }
    setWrappersWidthAndGap(width, gap) {
      if (!this.centerMode()) {
        if (this.itemsContainerVerticalPadding() !== undefined) {
          this.mainContainerPadding.set(this.itemsContainerVerticalPadding() === 0 ? '0' : `0 ${this.itemsContainerVerticalPadding()}px`);
        } else {
          this.mainContainerPadding.set(`0 ${gap}px`);
        }
      }
      const total = this.wrappers().length;
      this.mainContainerGap.set(gap + 'px');
      this.mainContainerWidth.set(total * width + (total + 1) * gap + 'px');
    }
    calculateSteps() {
      this.transitionSteps.set([]);
      const mainWidth = this.roundIt(this.mainContainer().nativeElement.getBoundingClientRect().width);
      const gap = this.calculatedGap();
      const slideWidth = this.calculatedWidth();
      this.stepWidth.set(slideWidth + gap);
      let step0 = gap / 2;
      if (this.centerMode()) {
        step0 = this.visibleItemCount() % 2 === 0 ? -slideWidth / 2 : -(mainWidth - slideWidth) / 2;
      } else {
        step0 = 0;
      }
      this.wrappers().forEach((wrapper, index) => {
        this.transitionSteps.update(prev => [...prev, this.roundIt(step0 + index * this.stepWidth())]);
      });
      if (this.index() > 0) {
        this.updateActiveSlide();
      } else {
        this.translateItemsContainer(this.transitionSteps()[this.cloneCount()], true);
      }
    }
    // Start the carousel movement
    onSwipeStart(e) {
      this.isDragging = true;
      this.rebootAutoPlay();
      this.currentWalkX = 0;
      this.itemsContainer().nativeElement.style.transition = 'none';
    }
    handleSwipingVertically(event) {
      this.isSwipingVertically = event;
    }
    // Carousel is on the move
    swiping(e) {
      if (!this.isDragging) return;
      if (!this.isSwipingVertically) {
        this.isSwiping.emit(true);
        this.currentWalkX = e.deltaX;
        let totalWalk = this.currentWalkX + this.lastLeft;
        // For Loop Mode
        if (this.loopMode()) {
          const steps = this.transitionSteps();
          const startHotSpot = this.loopStartHotSpot();
          const endHotSpot = this.loopEndHotSpot();
          const slides = this.slides();
          const visibleCount = this.visibleItemCount();
          // Swipe right: passed the first cloned item (visible clones on left)
          if (totalWalk > endHotSpot) {
            const overshoot = endHotSpot - totalWalk;
            totalWalk = steps[slides.length - visibleCount - 1] + overshoot;
            this.lastLeft = totalWalk + this.currentWalkX;
          }
          // Swipe left: passed the last cloned item (visible clones on right)
          if (totalWalk < startHotSpot) {
            const overshoot = totalWalk - startHotSpot;
            totalWalk = steps[slides.length + 1] + overshoot;
            this.lastLeft = totalWalk - this.currentWalkX;
          }
          this.itemsContainer().nativeElement.style.transition = 'none';
        }
        this.itemsContainer().nativeElement.style.transform = `translateX(${totalWalk}px)`;
      }
    }
    onSwipedX() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.updateActiveSlide();
    }
    // Carousel move is ended
    onSwipeEnd() {
      this.isSwiping.emit(false);
    }
    calculateNearestTranslatePoint(totalWalkX) {
      const length = this.transitionSteps().length;
      if (!length) {
        return 0;
      }
      let downIndex = 0;
      let upIndex = 1;
      const thresholdRatio = this.changeStepThresholdPercentage() / 100;
      // Calculate Up and Down in Array
      if (totalWalkX > this.transitionSteps()[length - 1]) {
        upIndex = length - 1;
        downIndex = length - 2;
      } else {
        for (let i = 0; i < length; i++) {
          if (i < length - 1) {
            if (totalWalkX < this.transitionSteps()[i]) {
              upIndex = i;
              downIndex = i - 1;
              break;
            }
          } else {
            upIndex = length - 1;
            downIndex = length - 2;
            break;
          }
        }
      }
      if (upIndex === 0) {
        downIndex = 0;
        upIndex = 1;
      }
      // Calculate the transition threshold based on the provided percentage
      const stepDistance = this.transitionSteps()[upIndex] - this.transitionSteps()[downIndex];
      const thresholdDistance = stepDistance * thresholdRatio;
      const downDistance = Math.abs(this.transitionSteps()[downIndex] - totalWalkX);
      const upDistance = Math.abs(this.transitionSteps()[upIndex] - totalWalkX);
      // Choose the nearest point based on the threshold distance
      const moveRight = this.currentWalkX > 0;
      return moveRight ? downDistance > thresholdDistance ? this.transitionSteps()[upIndex] : this.transitionSteps()[downIndex] : upDistance > thresholdDistance ? this.transitionSteps()[downIndex] : this.transitionSteps()[upIndex];
    }
    handleNavigationBtnClick(direction) {
      const lastIndex = this.wrappers().length - 1;
      const isLastOne = this.index() === 1 || this.index() === lastIndex - 1;
      if (this.enableAutoPlay()) this.rebootAutoPlay();
      if (direction === 'NEXT') {
        if (this.index() < lastIndex) {
          this.index.update(v => isLastOne && this.loopMode() ? v - this.slides().length : v + 1);
        }
      } else if (direction === 'PREV') {
        if (this.index() > 0) {
          this.index.update(v => isLastOne && this.loopMode() ? v + this.slides().length : v - 1);
        }
      }
      this.navigationBtnClicked.emit(direction);
      this.step(false);
    }
    step(isDragging = true, animate = true, lastLeft) {
      this.lastLeft = lastLeft ?? this.transitionSteps()[this.loopMode() && this.index() === 0 ? this.cloneCount() : this.index()];
      this.updateActiveSlide(isDragging, animate);
    }
    updateActiveSlide(isDragging = true, animate = true) {
      const steps = this.transitionSteps();
      if (!steps.length) return;
      const totalWalkX = isDragging ? this.currentWalkX + this.lastLeft : this.lastLeft;
      const translateAmount = this.calculateNearestTranslatePoint(totalWalkX);
      let newIndex = steps.indexOf(translateAmount);
      this.index.set(newIndex);
      this.lastLeft = translateAmount;
      this.translateItemsContainer(translateAmount, animate);
    }
    translateItemsContainer(amount, animate) {
      amount = this.roundIt(amount);
      const el = this.itemsContainer().nativeElement;
      el.style.transition = animate ? 'transform 0.5s ease-in-out' : 'none';
      el.style.transform = `translateX(${amount}px)`;
    }
    startAutoPlay() {
      if (!this.enableAutoPlay()) return;
      if (this.autoPlayIntervalId) return;
      this.autoPlayIntervalId = setInterval(() => {
        const next = this.index() + 1;
        const last = this.wrappers().length - this.cloneCount();
        this.previousIndex = this.index();
        if (next < last) {
          this.index.set(next);
        } else if (this.loopMode()) {
          this.index.set(this.cloneCount());
          this.step(false, false, this.transitionSteps[this.cloneCount()]);
        } else {
          if (this.autoPlayCounts()) {
            this.autoPlayExecutedCount++;
            if (this.autoPlayExecutedCount >= this.autoPlayCounts()) {
              clearInterval(this.autoPlayIntervalId);
            }
          }
          return;
        }
      }, this.autoPlayDurationMillis());
    }
    rebootAutoPlay() {
      if (this.autoPlayIntervalId) {
        clearInterval(this.autoPlayIntervalId);
        this.autoPlayIntervalId = undefined;
      }
      if (!this.autoPlayRebootTimeoutId) {
        this.autoPlayRebootTimeoutId = setTimeout(() => {
          this.startAutoPlay();
        }, this.autoPlayRebootDurationMillis());
      }
    }
    roundIt(value) {
      return Math.round(value * 10) / 10;
    }
    handleAnimationRunning(isRunning) {
      this.isAnimating = isRunning;
      this.isAnimationRunning.emit(isRunning);
      if (!isRunning) {
        if (this.loopMode()) {
          const index = this.index();
          const length = this.wrappers().length;
          const realLength = this.slides().length;
          if (index === length - 3) {
            if (this.lastNavigationDirection() === 'NEXT') {
              this.step(false, false, this.transitionSteps()[index - realLength]);
            }
          } else if (index === 1) {
            this.step(false, false, this.transitionSteps()[index + realLength]);
          }
        }
      }
    }
    handleSingleTap() {
      if (!this.isAnimating) {
        this.singleTapped.emit();
      }
    }
    ngOnDestroy() {
      if (this.autoPlayRebootTimeoutId) {
        clearTimeout(this.autoPlayRebootTimeoutId);
      }
      if (this.autoPlayIntervalId) {
        clearInterval(this.autoPlayIntervalId);
      }
    }
    static {
      this.ɵfac = function NgxDpCarouselComponent_Factory(t) {
        return new (t || NgxDpCarouselComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxDpCarouselComponent,
        selectors: [["ngx-dp-carousel"]],
        contentQueries: function NgxDpCarouselComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuerySignal(dirIndex, ctx.slides, NgxDpCarouselSlideDirective, 4);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        viewQuery: function NgxDpCarouselComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.itemsContainer, _c0, 5);
            i0.ɵɵviewQuerySignal(ctx.mainContainer, _c1, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          visibleItemCount: [i0.ɵɵInputFlags.SignalBased, "visibleItemCount"],
          numScroll: [i0.ɵɵInputFlags.SignalBased, "numScroll"],
          carouselPadding: [i0.ɵɵInputFlags.SignalBased, "carouselPadding"],
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          mainContainerClasses: [i0.ɵɵInputFlags.SignalBased, "mainContainerClasses"],
          swipeThreshold: [i0.ɵɵInputFlags.SignalBased, "swipeThreshold"],
          fixedWidth: [i0.ɵɵInputFlags.SignalBased, "fixedWidth"],
          fixedGap: [i0.ɵɵInputFlags.SignalBased, "fixedGap"],
          itemsContainerVerticalPadding: [i0.ɵɵInputFlags.SignalBased, "itemsContainerVerticalPadding"],
          index: [i0.ɵɵInputFlags.SignalBased, "index"],
          scaleAmount: [i0.ɵɵInputFlags.SignalBased, "scaleAmount"],
          isFixedWidth: [i0.ɵɵInputFlags.SignalBased, "isFixedWidth"],
          isFixedGap: [i0.ɵɵInputFlags.SignalBased, "isFixedGap"],
          centerMode: [i0.ɵɵInputFlags.SignalBased, "centerMode"],
          disableScaling: [i0.ɵɵInputFlags.SignalBased, "disableScaling"],
          showNavigation: [i0.ɵɵInputFlags.SignalBased, "showNavigation"],
          showDots: [i0.ɵɵInputFlags.SignalBased, "showDots"],
          showButtons: [i0.ɵɵInputFlags.SignalBased, "showButtons"],
          isSlideOverflowVisible: [i0.ɵɵInputFlags.SignalBased, "isSlideOverflowVisible"],
          navigationContainerClasses: [i0.ɵɵInputFlags.SignalBased, "navigationContainerClasses"],
          navigationDotsContainerClasses: [i0.ɵɵInputFlags.SignalBased, "navigationDotsContainerClasses"],
          disableNavigationDots: [i0.ɵɵInputFlags.SignalBased, "disableNavigationDots"],
          navigationButtonSize: [i0.ɵɵInputFlags.SignalBased, "navigationButtonSize"],
          navigationButtonNextText: [i0.ɵɵInputFlags.SignalBased, "navigationButtonNextText"],
          navigationButtonPrevText: [i0.ɵɵInputFlags.SignalBased, "navigationButtonPrevText"],
          scalingTransformOrigin: [i0.ɵɵInputFlags.SignalBased, "scalingTransformOrigin"],
          changeStepThresholdPercentage: [i0.ɵɵInputFlags.SignalBased, "changeStepThresholdPercentage"],
          enableAutoPlay: [i0.ɵɵInputFlags.SignalBased, "enableAutoPlay"],
          autoPlayDurationMillis: [i0.ɵɵInputFlags.SignalBased, "autoPlayDurationMillis"],
          autoPlayCounts: [i0.ɵɵInputFlags.SignalBased, "autoPlayCounts"],
          autoPlayRebootDurationMillis: [i0.ɵɵInputFlags.SignalBased, "autoPlayRebootDurationMillis"],
          loopMode: [i0.ɵɵInputFlags.SignalBased, "loopMode"]
        },
        outputs: {
          index: "indexChange",
          navigationBtnClicked: "navigationBtnClicked",
          isAnimationRunning: "isAnimationRunning",
          singleTapped: "singleTapped",
          isSwiping: "isSwiping"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 18,
        consts: [["ngxDpCarouselMainContainer", ""], ["ngxDpCarouselItemsContainer", ""], ["navigationContainer", ""], [3, "ngStyle"], ["ngxSwipeDetector", "", 1, "items-container", "d-flex", "justify-center", 3, "transitionstart", "transitionend", "swipeStart", "swiping", "isSwipingVertically", "singleTap", "swipedX", "swipeEnd", "ngClass", "axisToLockOn", "swipeThreshold"], [3, "class", "ngStyle", "overflow", "clone"], [3, "class"], [3, "ngTemplateOutlet"], [1, "buttons", "d-flex", "flex-row", "gap-medium"], [1, "dot", "radius-giant", 3, "ngClass"], [3, "mode", "style", "size", "leftIcon"], [3, "clickHandler", "mode", "size", "leftIcon"]],
        template: function NgxDpCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 3, 0)(2, "div", 4, 1);
            i0.ɵɵlistener("transitionstart", function NgxDpCarouselComponent_Template_div_transitionstart_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleAnimationRunning(true));
            })("transitionend", function NgxDpCarouselComponent_Template_div_transitionend_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleAnimationRunning(false));
            })("swipeStart", function NgxDpCarouselComponent_Template_div_swipeStart_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSwipeStart($event));
            })("swiping", function NgxDpCarouselComponent_Template_div_swiping_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.swiping($event));
            })("isSwipingVertically", function NgxDpCarouselComponent_Template_div_isSwipingVertically_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSwipingVertically($event));
            })("singleTap", function NgxDpCarouselComponent_Template_div_singleTap_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleSingleTap());
            })("swipedX", function NgxDpCarouselComponent_Template_div_swipedX_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSwipedX());
            })("swipeEnd", function NgxDpCarouselComponent_Template_div_swipeEnd_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSwipeEnd());
            });
            i0.ɵɵrepeaterCreate(4, NgxDpCarouselComponent_For_5_Template, 2, 8, "div", 5, _forTrack0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, NgxDpCarouselComponent_Conditional_6_Template, 4, 4, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap("carousel d-flex flex-column " + ctx.mainContainerClasses());
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c2, ctx.carouselPadding()));
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("gap", ctx.mainContainerGap())("width", ctx.mainContainerWidth())("padding", ctx.mainContainerPadding());
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c3, ctx.mode() === "CARD"))("axisToLockOn", "X")("swipeThreshold", ctx.swipeThreshold());
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.wrappers());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(6, ctx.showNavigation() ? 6 : -1);
          }
        },
        dependencies: [NgStyle, NgClass, NgxSwipeDetectorDirective, NgxButtonComponent, NgTemplateOutlet],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}[_nghost-%COMP%]{width:100%;display:block}.carousel[_ngcontent-%COMP%]{width:100%;overflow:hidden;direction:rtl}.carousel-inner[_ngcontent-%COMP%]{display:flex;transition:transform .5s ease-in-out}.items-container[_ngcontent-%COMP%]{position:relative;flex:1;width:100%;border:none;cursor:pointer;overflow:visible}.items-container[_ngcontent-%COMP%]   .carousel-item[_ngcontent-%COMP%]{transition:transform .5s ease-in-out,width .5s ease-in-out,height .5s ease-in-out}.items-container.cards.active[_ngcontent-%COMP%]{transform:scale(1.2)}.items-container.cards.is-next[_ngcontent-%COMP%], .items-container.cards.is-prev[_ngcontent-%COMP%]{transform:scale(.8)}.navigation-container[_ngcontent-%COMP%]   .dots[_ngcontent-%COMP%]   .dot[_ngcontent-%COMP%]{width:6px;height:6px;background:var(--onelevated-shade-80);transition:width .5s ease-out,background-color .5s ease-in}.navigation-container[_ngcontent-%COMP%]   .dots[_ngcontent-%COMP%]   .dot.active[_ngcontent-%COMP%]{width:14px;background:var(--onback-shade-20)}.carousel-control[_ngcontent-%COMP%]{justify-content:center;padding:8px}"],
        changeDetection: 0
      });
    }
  }
  return NgxDpCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-dp-carousel
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxDpCarouselComponent, NgxDpCarouselSlideDirective };
